// =============================================================================
// FILE: packages/renderer/src/stores/launcher.store.ts
// PURPOSE: Tiny global store for the Cyberpunk Launcher open state.
//          Mirrors the shape of pfeStore so any module can toggle the
//          launcher without prop drilling.
// =============================================================================

import { useSyncExternalStore } from 'react';

interface LauncherState { open: boolean }

const subs = new Set<() => void>();
let state: LauncherState = { open: false };
function notify(): void { for (const s of subs) s(); }

export const launcherStore = {
  getState: (): LauncherState => state,
  open():    void { state = { open: true  }; notify(); },
  close():   void { state = { open: false }; notify(); },
  toggle():  void { state = { open: !state.open }; notify(); },
  subscribe(fn: () => void): () => void { subs.add(fn); return () => subs.delete(fn); },
};

export function useLauncherStore(): LauncherState {
  return useSyncExternalStore(launcherStore.subscribe, launcherStore.getState, launcherStore.getState);
}
